import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {usePricingDiscountRoleConfig} from "../../../@hooks";
import {elementsInLoading} from "../../../@signals";


export default function usePriceDiscountTopData() {
	const { urlApi } = usePricingDiscountRoleConfig()

	const isLoading = useSignal(false)
	const data = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = []
			postSubmit(`${urlApi}/top-discount`, { ...commonFiltersValue.value }).then(res => data.value = res.topDiscount)
				.catch(() => {
					isLoadingCommonFilters.value = false
					isSystemBusy.value = true
				}).finally(() => isLoading.value = false)
		}
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'topDiscount']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'topDiscount')
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		data: data.value
	}
}